import React from 'react';
import { Link } from "react-router-dom";
import './App.css';


const Refs = () => {
  return (
    <div className="App">
      <header className="App-header">
        <p className="Link"><Link to="/">Zurück zum Steuerrechner</Link></p>
      </header>
      <main>
      <p>Test</p>
      </main>
        <footer className="App-footer">
        <h className="Hafti">Haftungsausschluss: Diese Anwendung dient nur zu Informationszwecken. Die Berechnungen sind unverbindlich und ersetzen keine professionelle Steuerberatung.</h>
        <p className="Link"><Link to="/">Zurück</Link></p>
      </footer>
    </div>
  );
};

export default Refs;